import React from 'react';
import './CartSkeleton.css';

interface CartSkeletonProps {
  itemCount?: number;
}

export const CartItemSkeleton: React.FC = () => {
  return (
    <div className="cart-item-skeleton">
      <div className="skeleton-cart-image-wrap">
        <div className="skeleton-cart-image" />
      </div>
      <div className="skeleton-cart-details">
        <div className="skeleton-cart-title" />
        <div className="skeleton-cart-chips" />
        <div className="skeleton-cart-price" />
      </div>
      <div className="skeleton-cart-right">
        <div className="skeleton-cart-remove" />
        <div className="skeleton-cart-quantity" />
      </div>
    </div>
  );
};

export const CartSkeleton: React.FC<CartSkeletonProps> = ({ itemCount = 3 }) => {
  return (
    <div className="cart-skeleton">
      <div className="cart-skeleton-main">
        <div className="cart-skeleton-section-head">
          <div className="skeleton-cart-header-title" />
          <div className="skeleton-cart-header-count" />
        </div>
        <div className="cart-skeleton-card">
          <div className="skeleton-cart-items">
            {Array.from({ length: itemCount }).map((_, index) => (
              <CartItemSkeleton key={index} />
            ))}
          </div>
          <div className="skeleton-cart-footer">
            <div className="skeleton-cart-footer-btn" />
            <div className="skeleton-cart-footer-total" />
          </div>
        </div>
      </div>
      <div className="cart-skeleton-summary">
        <div className="skeleton-summary-card">
          <div className="skeleton-summary-head">
            <div className="skeleton-summary-title" />
          </div>
          <div className="skeleton-summary-body">
            <div className="skeleton-order-type" />
            <div className="skeleton-summary-details">
              <div className="skeleton-summary-row" />
              <div className="skeleton-summary-row" />
              <div className="skeleton-summary-row total" />
            </div>
          </div>
          <div className="skeleton-checkout-wrap">
            <div className="skeleton-checkout-btn" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartSkeleton;
